import React from "react";
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { FaUsers, FaCalendarAlt, FaChartLine, FaShieldAlt, FaMobileAlt, FaHeadset, FaDumbbell, FaTrophy, FaClipboardList } from 'react-icons/fa';
import "./Funcionalidades.css";

const Funcionalidades = () => {
    const { t } = useTranslation();

    return (
        <div className="funcionalidades-container">
            <SEO
                titleKey="seo.features.title"
                descriptionKey="seo.features.description"
                image="/images/seo/ExercisesMyCoachServer.png"
            />
            <div className="funcionalidades-content">
                <h1>{t('pages.features.title')}</h1>
                <p>{t('pages.features.subtitle')}</p>

                <div className="funcionalidades-list">
                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaUsers /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature1Title')}</h3>
                            <p>{t('pages.features.feature1Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaCalendarAlt /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature2Title')}</h3>
                            <p>{t('pages.features.feature2Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaDumbbell /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature3Title')}</h3>
                            <p>{t('pages.features.feature3Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaChartLine /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature4Title')}</h3>
                            <p>{t('pages.features.feature4Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaTrophy /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature5Title')}</h3>
                            <p>{t('pages.features.feature5Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaClipboardList /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature6Title')}</h3>
                            <p>{t('pages.features.feature6Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaShieldAlt /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature7Title')}</h3>
                            <p>{t('pages.features.feature7Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaMobileAlt /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature8Title')}</h3>
                            <p>{t('pages.features.feature8Desc')}</p>
                        </div>
                    </div>

                    <div className="funcionalidade-item">
                        <div className="icon-placeholder" aria-hidden="true"><FaHeadset /></div>
                        <div className="funcionalidade-text">
                            <h3>{t('pages.features.feature9Title')}</h3>
                            <p>{t('pages.features.feature9Desc')}</p>
                        </div>
                    </div>
                </div>

            </div>

            <div className="cta">
                <p>{t('pages.features.ctaText')}</p>
                <a href="/pricing" className="btn-preco">{t('pages.features.ctaButton')}</a>
            </div>
        </div>
    );
};

export default Funcionalidades;